export default "__VITE_ASSET__vpEW1foi__"